import React from "react";
import { Link } from "react-router-dom";
import constants from "../../config/config";

// "Start your 14-day free trial" only links to checkout once enrollment is live.
// Until then the button sends people to the Premium membership page instead.
export const isTrialLive = () =>
  Boolean(constants.launch.TRIAL_LIVE && constants.launch.TRIAL_URL);

const TrialCta = ({ className = "mrf-btn mrf-btn--primary", liveLabel = "Start your 14-day free trial", fallbackLabel = "See Premium membership" }) => {
  if (isTrialLive()) {
    return (
      constants.launch.TRIAL_URL.startsWith("/") ? (
        <Link className={className} to={constants.launch.TRIAL_URL}>
          {liveLabel}
        </Link>
      ) : (
        <a className={className} href={constants.launch.TRIAL_URL}>
          {liveLabel}
        </a>
      )
    );
  }
  return (
    <Link className={className} to="/pricing">
      {fallbackLabel}
    </Link>
  );
};

export default TrialCta;
